export const SCHEDULE_AB_6_COLUMNS = {
  gridColumns: [
    {
      dataType: 'string',
      displayName: 'Legal Entity',
      propertyName: 'legalEntityId',
    },
    {
      allowedValues: ['Crop', 'FarmAnimal', 'FarmMachine', 'Supplies', 'Other'],
      dataType: 'enum',
      displayName: 'Type of Farm Asset',
      propertyName: 'typeOfFarmAsset',
      queryType: 'ScheduleTypeOfFarmAsset'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Description',
      propertyName: 'description',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Book Value',
      propertyName: 'bookValue',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Value Method',
      propertyName: 'valueMethod',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Current Value',
      propertyName: 'currentValue',
    },
    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Depreciation Schedule',
      propertyName: 'depreciationSchedule',
    },
    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Appraised',
      propertyName: 'appraised',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Property Book Value',
      propertyName: 'propertyBookValue',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Property Valuation Method',
      propertyName: 'propertyValuationMethod',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Property Current Value',
      propertyName: 'propertyCurrentValue',
    },
    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Agri Co-Op',
      propertyName: 'agriCoOp',
    },
    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Property Stored at Co-Op',
      propertyName: 'propertyStoredAtCoOp',
    },

    {
      allowedValues: ['No', 'All', 'Address', 'Name'],
      dataType: 'enum',
      displayName: 'Redact',
      propertyName: 'redact',
      queryType: 'RedactType'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Footnote',
      propertyName: 'footnote',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Entity Comments',
      propertyName: 'entityComments',
    },
  ],
};
